<template>
    <div class="field-container-2">
        <div class="regular-type-header">
            {{header}}
        </div>
        <v-switch
                v-model="value"
                :hint="description"
                :persistent-hint="true"
                :required="isRequired"
                @change="emitInput"
        ></v-switch>
    </div>

</template>

<script>
    import {EVENT_INPUT, EVENT_TOUCHED, DEFAULT_LOCALE, GET_LOCALE_DISPLAY_NAME} from '../../services/constants'

    export default {
        name: 'sfr-boolean-field',
        props: ['field', 'inputValue'],
        model: {
            prop: 'inputValue',
            event: EVENT_INPUT
        },
        data: function () {
            return {
                isRequired: this.field.required,
                value: this.inputValue ? this.inputValue : '',
            }
        },
        computed: {
            header: function () {
                return this.computeFieldHeader(this.field)
            },
            description: function () {
                const currentLocale = this.$store.state.locale.currentLocale
                return currentLocale === DEFAULT_LOCALE ? this.field.description : `${this.field.description} (${this.$store.getters[GET_LOCALE_DISPLAY_NAME](currentLocale)})`
            },
        },
        methods: {
            computeFieldHeader: function (field) {
                return `${field.name}${field.required ? '* ' : ''}:`
            },
            emitInput: function ($event) {
                this.$emit(EVENT_INPUT, $event)
                this.$emit(EVENT_TOUCHED, true)
            },
        },
    }
</script>

<style scoped lang="scss">
    @import "../../meta";

    .field-container-1 {
        margin: 2em 0;
        .field-container-2 {
            padding: 0 1em;
            $border-width: 3px;
            border-left: $border-width solid $accent;
            border-radius: $border-width;
        }
    }

    .regular-type-header {
        font-size: 14px;
        .input-group {
            padding: 0px;
        }
    }


</style>
